import React from 'react';
import { DiscoverLogo as BaseDiscoverLogo } from '@move-frontend/form';
import { useTranslationForType } from '../hooks/useTranslationForType';
import { CreditCardType } from '../../../domain/models';

export const DiscoverLogo = () => {
	const alt = useTranslationForType(CreditCardType.Discover);

	return <BaseDiscoverLogo alt={alt} />;
};
